import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/utils/http'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

const state = {
	token: getToken(),
	chan: {},
	user: {},
  avatar: '',
  name: '',
  role:[],
  privilege:[]
}

const mutations = {
	setToken: (state, token) => {
		state.token = token
	},
	setChan(state, payload) {
		if (Object.keys(payload).length == 0) {
			state.chan = {}
			return
		}
		state.chan = Object.assign({}, state.chan, payload)
	},
	setUser(state, payload) {
		state.user = payload
	},
	setAvatar(state, payload) {
		state.avatar = payload
	},
	setName(state, payload) {
		state.name = payload
	},
	setRole(state, payload) {
		state.role = payload
	},
	setPrivilege(state, payload) {
		state.privilege = payload
	}
}

const actions = {
	login({commit}, payload) {
		let data = {
			com: payload.com, 
			code: payload.code, 
			pwd: payload.pwd
		}
		return new Promise(resolve => {
			http.post('/api/auth/w-login/', data).then(resp => {
				if (resp.code == 0) {
					commit('setToken', resp.data.token)
					setToken(resp.data.token)
				}
				resolve(resp)
			})
		})
	},
	getInfo({commit}) {
		return new Promise((resolve, reject) => {
			http.post('/api/auth/info/').then(resp => {
				if (resp.code != 0) {
					reject('error')
				}

        const { role, privilege, avatar, name } = resp.data
				commit('setUser', resp.data)
        commit('setRole', role)
        commit('setPrivilege', privilege)
        commit('setAvatar', avatar)
        commit('setName', name)
				resolve(resp)
			})
		})
	},
	logout({commit, dispatch}) {
		return new Promise((resolve) => {
			http.post('/api/auth/w-logout/').then(() => {
				commit('setToken', '')
        commit('setRole', [])
        commit('setPrivilege', [])
				removeToken()

        dispatch('tagsView/delAllViews', null, { root: true })
				resolve()
			})
		})
	},
	FedLogOut({commit}) {
		return new Promise(resolve => {
			commit('setToken', '')
			removeToken()
			resolve()
		})
	}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
